import { useEffect } from 'react'

import { useStoreContext } from 'hooks/StoreContext'
import { useSessionContext } from 'hooks/SessionContext'
import { useFeaturesContext } from 'hooks/FeaturesContext'

import Api from 'services/api'

import Brand from 'helpers/brand'

interface UseSiteMessagesProps {
  listForAllBrands?: boolean
  listForAllTiers?: boolean
  getPublishedOnly?: boolean
  refreshTimestamp?: number | string
}

interface ISiteMessagesReturn {
  siteMessages: unknown[] | null
  areSiteMessagesLoaded: boolean
}

const useSiteMessages = ({
  listForAllBrands = false,
  listForAllTiers = false,
  getPublishedOnly = false,
  refreshTimestamp
}: UseSiteMessagesProps = {}): ISiteMessagesReturn => {
  const {
    siteMessages,
    setSiteMessages,
    areSiteMessagesLoaded,
    setAreSiteMessagesLoaded
  } = useStoreContext()

  const { session } = useSessionContext()
  const { FreeTrial } = useFeaturesContext()

  useEffect(() => {
    const brands = listForAllBrands
      ? Brand.allBrandsOfCurrentBusinessUnit().join(',')
      : Brand.current()

    const currentTier = FreeTrial
      ? 'trial'
      : session.dealerPlan.tier

    const tiers = listForAllTiers
      ? 'standard,premium,trial'
      : currentTier

    Api.SiteMessages.list(brands, tiers, getPublishedOnly)
      .then((res: unknown[]) => {
        setSiteMessages(res)
        setAreSiteMessagesLoaded(true)
      })
      .catch(() => {
        setSiteMessages(null)
        setAreSiteMessagesLoaded(true)
      })
  }, [getPublishedOnly, refreshTimestamp]) // eslint-disable-line react-hooks/exhaustive-deps

  return {
    siteMessages,
    areSiteMessagesLoaded
  }
}

export default useSiteMessages
